export const BannerLevel = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL',
}

export function getBannerColor(level) {
  switch (level) {
    case BannerLevel.INFO:
      return '#c4e0ca'
    case BannerLevel.WARNING:
      return '#f8cf8e'
    case BannerLevel.CRITICAL:
      return '#ed9e9e'
    default:
      return '#000'
  }
}
